import { CardType, PaymentType } from './paymentauthorization.model';
import { WalletInfo } from './walletInfo.model';
export class PaymentMethod {
  cardId = '';
  paymentType!: PaymentType;
  debitLast4!: number;
  accountType = '';
  routingNumber = '';
  institutionName = '';
  expirationDate = '';
  cardType: CardType = 'OTHER';
  accountId = '';
  token = '';
  firstName = '';
  lastName = '';
  addressLine1 = '';
  addressLine2 = '';
  city = '';
  state = '';
  zip = '';
  country = '';
  walletId = '';
  walletName = '';
  invalid = false;
}

export class WalletDelete {
  cardId = '';
  forceDelete = false;
}

export class WalletDeleteResponse {
  cardId = '';
  isSuccessful = true;
  reasonCode = 200;
  reasonDescription = 'Success';

  automatedPaymentIds: string[] = [];
  authorizationIds: string[] = [];
  paymentPlanIds: string[] = [];
  scheduledPayments: string[] = [];
}

export class WalletPayment {
  firstName = '';
  lastName = '';
  emailAddress = '';
  token = '';
  accountId = '';
  ccOrEc: 'ECHECK' | 'CREDIT_CARD' = 'CREDIT_CARD';
  maskedCardNumber = '';
  addressLine1? = '';
  addressLine2? = '';
  cityName? = '';
  stateCode? = '';
  postalCode? = '';
  countryCode? = '';
  expirationMonth = '';
  expirationYear = '';
  cardTypeCD?: 'MC' | 'DI' | 'AX' | 'VI' = 'MC';
  accountType? = '';
  routingNumber? = '';
  invalid = false;
}

export class WalletPaymentResponse {
  cardID = '';
  isSuccessful = true;
  reasonCode = 200;
  reasonDescription = 'Success';
}

export class WalletRetrieveResponse {
  listWalletPayments: WalletInfo[] = [];
  isSuccessful = true;
  reasonCode = 200;
  reasonDescription = 'Success';
}

export class InvoiceDetail {
  balance = 0;
  lcaInvoiceNumber = '';
  specimenNumber = '';
  dateOfService = null;
  initialPaymentAmount = null;
  requisitionNumber = null;
}

export class PaymentPlan {
  paymentPlanId = '';
  totalInstallments = 0;
  installmentAmount = 0;
  planAmount = 0;
  remainingInstallments = 0;
  installmentType = '';
  firstInstallmentDate = '';
  lastInstallmentDate = '';
  nextInstallmentDate = '';
  cardType = '';
  cardLastFourDigits = '';
  invoiceDetails: InvoiceDetail[] = [];
}

export class ActivePaymentsResponse {
  patientName = '';
  id = 0;
  payPlans: PaymentPlan[] | null = [];
}
